import breakpoints from 'Utils/breakpoints';
import { mqs } from './plugin';

const currentMq = mqs(breakpoints);
let overlayOpener = null;

function layoutType(mq) {
  if (breakpoints.layoutNames.indexOf(mq) > 2) {
    return 'desktop';
  } else if (breakpoints.layoutNames.indexOf(mq) > 1) {
    return 'tablet';
  }

  return 'mobile';
}

export const actions = {
  escapeKey({ commit, state: actionState }) {
    if (!actionState.escapeStack.length || actionState.overlay.busy) {
      return;
    }

    const mutationName = actionState.escapeStack[0];

    commit(mutationName, false);
    commit('removeFromEscapeStack', 0);
  },
};

export const mutations = {
  breakpoint(mutationState, data) {
    mutationState.breakpoint = data;
    mutationState.layout = layoutType(data);
  },
  layout(mutationState, data) {
    mutationState.layout = data;
  },
  burgerMenu(mutationState, data) {
    mutationState.burgerMenu = data;
  },
  busy(mutationState, data) {
    mutationState.overlay.busy =
      data !== undefined ? data : !mutationState.overlay.busy;
  },
  escapeStack(mutationState, data) {
    if (data.opened) {
      mutationState.escapeStack.unshift(data.mutation);

      return;
    }

    const mutationIndex = mutationState.escapeStack.indexOf(data.mutation);

    if (mutationIndex < 0) {
      return;
    }

    mutationState.escapeStack.splice(mutationIndex, 1);
  },
  features(mutationState, data) {
    mutationState.features = {
      ...mutationState.features,
      ...data,
    };
  },
  height(mutationState, data) {
    mutationState.height = data;
  },
  heroOffset(mutationState, data) {
    mutationState.heroOffset = data;
  },
  inputType(mutationState, data) {
    if (typeof window !== 'undefined') {
      document.documentElement.classList.remove(
        `user-input-${mutationState.inputType}`
      );
      document.documentElement.classList.add(`user-input-${data}`);
    }

    mutationState.inputType = data;
  },
  loaded(mutationState, data) {
    mutationState.loaded = data;
  },
  removeFromEscapeStack(mutationState, index) {
    mutationState.escapeStack.splice(index, 1);
  },
  scrollTop(mutationState, data) {
    mutationState.scrollTop = data;
  },
  scrollDirection(mutationState, data) {
    mutationState.scrollDirection = data;
  },
  setOverlayOpener(mutationState, opener) {
    // only change the state if the overlay is opened
    if (!mutationState.overlay.opened) {
      return;
    }

    overlayOpener = opener;
  },
  toggleOverlay(mutationState, forcedValue) {
    if (typeof document !== 'undefined') {
      mutationState.overlay.opened =
        forcedValue !== undefined ? forcedValue : !mutationState.overlay.opened;

      // store opener overlay opener to refocus when overlay closes
      if (mutationState.overlay.opened && !overlayOpener) {
        overlayOpener = document.activeElement;
      } else if (overlayOpener) {
        overlayOpener.focus();
        overlayOpener = null;
      }

      document.documentElement.classList.toggle(
        '-overlay',
        mutationState.overlay.opened
      );
    }
  },
  ssr(mutationState, data) {
    mutationState.SSR = data;
  },
  width(mutationState, data) {
    mutationState.width = data;
  },
  setSearch(mutationState, data) {
    mutationState.search.opened = data;
  },
};

export const state = () => ({
  breakpoint: currentMq,
  breakpoints: breakpoints.layoutNames,
  burgerMenu: false,
  layout: layoutType(currentMq),
  escapeStack: [],
  heroOffset: null,
  features: {
    iOS:
      typeof navigator !== 'undefined'
        ? !!navigator.platform.match(/iPhone|iPod|iPad/)
        : false,
    storage: true,
  },
  height: null,
  inputType: 'mouse',
  loaded: false,
  overlay: {
    busy: false,
    opened: false,
    opener: null,
  },
  scrollTop: 0,
  scrollDirection: 0,
  ssr: typeof window === 'undefined',
  width: null,
  search: {
    opened: false,
  },
});

export const namespaced = true;
